import { useAccount } from "wagmi";
import { useShipsByTier } from "../../hooks";
import { ConnectPrompt, PageLayout } from "../shared";
import { FleetHero } from "./FleetHero";
import { ShipBuySection } from "./ShipBuySection";
import { ShipInventory } from "./ShipInventory";

interface ShipyardPageProps {
	onClose?: () => void;
}

export function ShipyardPage({ onClose }: ShipyardPageProps) {
	const { address, isConnected } = useAccount();
	const { ships, isLoading } = useShipsByTier(address);

	return (
		<PageLayout
			title="Shipyard"
			subtitle="Build your fleet and prepare for farming missions"
			onClose={onClose}
		>
			{!isConnected ? (
				<ConnectPrompt message="Connect your wallet to access the Shipyard" />
			) : (
				<>
					<FleetHero />
					<ShipBuySection />
					<ShipInventory ships={ships} isLoading={isLoading} />
				</>
			)}
		</PageLayout>
	);
}
